import {
  GET_AVAILABLE_VEHICLES,
  GET_AVAILABLE_VEHICLES_EMPTY,
  GET_AVAILABLE_VEHICLES_ERROR,
  GET_AVAILABLE_VEHICLES_SUCCESS,
} from '../../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const GetAvailableVehicles = (state = initialState, action) => {
  switch (action.type) {
    case GET_AVAILABLE_VEHICLES:
      state = {
        ...state,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case GET_AVAILABLE_VEHICLES_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case GET_AVAILABLE_VEHICLES_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case GET_AVAILABLE_VEHICLES_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default GetAvailableVehicles;
